import { instance as axios } from "@/hooks/axios/axios";
import moment from "moment";
import isEmpty from "lodash/isEmpty";
import errorHandler from "../errors/errorHandler";
// import { Userpilot } from "userpilot";

import transform from "../transform/transform";
import router from "@/router/router-loader";
import { getEssentialJobData } from "@/helpers/utility/jobDataSelector.js";
const {
  transformUserDataForRequest,
  transformJobData,
  transformShiftData,
  transformPreferredLocumData,
  transformPreferredLocumInvitationData,
} = transform();

export default {
  setJobDistancesData(store, data) {
    store.commit("setJobDistancesData", data);
  },

  setLoggedStatus(store, data) {
    store.commit("setLoggedStatus", data);
  },

  setPageBack(store, data) {
    store.commit("setPageBack", data);
  },
  setLastPage(store, data) {
    store.commit("setLastPage", data);
  },

  setAuthPageIntro(store, data) {
    store.commit("setAuthPageIntro", data);
  },
  addAuthPageBack(store, data) {
    store.commit("addAuthPageBack", data);
  },
  setAuthPageBack(store, data) {
    store.commit("setAuthPageBack", data);
  },
  getAuthPageBack({ state }) {
    return state.pages.auth.back.pop();
  },
  setJobCreatePageData(store, data) {
    console.log("🚀 ~ setJobCreatePageData ~ data:", data)
    store.commit("setJobCreatePageData", data);
  },

  setJobListingCreatePageData(store, data) {
    store.commit("setJobListingCreatePageData", data);
  },

  setGuestShiftRecordCreatePageData(store, data) {
    store.commit("setGuestShiftRecordCreatePageData", data);
  },

  setGuestShiftDetails(store, data) {
    store.commit("setGuestShiftDetails", data);
  },
  setGuestShiftPublic(store, data) {
    store.commit("setGuestShiftPublic", data);
  },
  clearJobCreatePageData(store) {
    store.commit("clearJobCreatePageData");
  },
  clearJobListingCreatePageData(store) {
    store.commit("clearJobListingCreatePageData");
  },

  clearGuesstShiftRecordCreatePageData(store) {
    store.commit("clearGuesstShiftRecordCreatePageData");
  },

  setJobShiftsBookPageData(store, data) {
    store.commit("setJobShiftsBookPageData", data);
  },
  clearJobShiftsBookPageData(store) {
    store.commit("clearJobShiftsBookPageData");
  },

  setJobDetails(store, data) {
    // Optimize the data before committing
    const optimizedData = getEssentialJobData(data.job);
    store.commit("setJobDetails", optimizedData);
  },
  setJobPreviewDetails(store, data) {
    store.commit("setJobPreviewDetails", data);
  },
  clearJobDetails(store) {
    store.commit("clearJobDetails");
  },

  setJobFiltersData(store, data) {
    store.commit("setJobFiltersData", data);
  },
  clearJobFiltersData(store) {
    store.commit("clearJobFiltersData");
  },

  setReportData(store, data) {
    store.commit("setReportData", data);
  },
  clearReportData(store) {
    store.commit("clearReportData");
  },

  setVerifyPageData(store, data) {
    store.commit("setVerifyPageData", data);
  },
  clearVerifyPageData(store, data) {
    store.commit("clearVerifyPageData", data);
  },
  setShiftApplictionDetails(store, data) {
    store.commit("setShiftApplictionDetails", data);
  },
  setLocumBlockedPharmacies(store, data) {
    store.commit("setLocumBlockedPharmacies", data);
  },
  setPharmacyTypes(store, data) {
    store.commit("setPharmacyTypes", data);
  },
  async CHECK_USER_EXIST(store, data) {
    try {
      const resp = await axios.get("user-exists", {
        params: data,
      });
      return resp.data.status;
    } catch (error) {
      errorHandler(error);
    }
  },

  AUTH_SUCCESS(store, data) {
    store.commit("AUTH_SUCCESS", data);
  },

  async AUTH_REGISTER(store, data) {
    const previousLinkStore = localStorage.getItem(
      "preferred_locum_invitation_id"
    );
    const associationId = localStorage.getItem(
      "association_id"
    );
    let formDataObject = {
      device_name: navigator.platform,
      role: store.getters.GET_USER_DATA.role,
      platform_role: store.getters.GET_USER_DATA.platformRole
        ? store.getters.GET_USER_DATA.platformRole
        : null,
      work_type: store.getters.GET_USER_DATA.workType
        ? store.getters.GET_USER_DATA.workType
        : null,
      invitation_id: previousLinkStore ? previousLinkStore : null,
      association_id: associationId ? associationId : null,
    };
    Object.assign(formDataObject, data);

    try {
      const resp = await axios.post("sign-up", formDataObject);
      localStorage.removeItem("preferred_locum_invitation_id");
      store.commit("SET_USER_DATA", resp.data.user);
      store.dispatch("AUTH_SUCCESS", resp.data.token);
    } catch (error) {
      errorHandler(error);
    }
  },

  async FETCH_PREFERRED_LOCUM() {
    try {
      let resp = await axios.get("pharmacy/preferred-locums");

      resp.data.data.forEach((element) => {
        transformPreferredLocumData(element);
      });

      console.log(resp.data);
      console.log("Hello data");
      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async FETCH_PREFERRED_LOCUM_FOR_PHARMACY(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/preferred-locums/invitations"
      );

      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async FETCH_INTERNAL_POOL_FOR_PHARMACY(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/internal-pool/invitations"
      );

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async FETCH_GUEST_LOCUM_FOR_PHARMACY(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/guest-locums/invitations"
      );

      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async FETCH_PREFERRED_LOCUM_PROFILE(store, data) {
    try {
      console.log("this is invitation id in action", data.invitationId);
      let resp = await axios.get(
        "pharmacy/preferred-locum/invitation-details/" + data.invitationId
      );

      return transformPreferredLocumInvitationData(resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async REMOVE_PREFERRED_LOCUM(store, data) {
    try {
      let resp = await axios.post(
        "pharmacy/remove/preferred-locums-by-invitation/" + data.invitationId
      );

      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async CANCEL_INTERNAL_POOL_INVITATION(store, data) {
    try {
      let resp = await axios.post(store.getters.GET_USER_DATA.role +
        "/cancel-internal-pool-invitation/" + data.invitationId
      );

      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async REMOVE_INTERNAL_POOL(store, data) {
    try {
      let resp = await axios.post(store.getters.GET_USER_DATA.role +
        "/remove-internal-pool/" + data.listId + "/" + data.userId
      );

      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async REMOVE_PREFERRED_LOCUMS_PHARMACY(store, data) {
    try {
      console.log("this is invitation id in action", data.pharmacyId);
      let resp = await axios.delete(
        "locum/preferred-locum/pharmacy/remove/" + data.pharmacyId
      );

      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async FETCH_PREFERRED_LOCUM_PHARMACIES() {
    try {
      let resp = await axios.get("locum/preferred-locum/pharmacies");

      console.log(resp.data);
      console.log("Hello phamacies");

      resp.data.data.forEach((element) => {
        transformPreferredLocumData(element);
      });

      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async AUTH_LOGIN(store, data) {
    let formDataObject = {
      device_name: navigator.platform,
    };
    Object.assign(formDataObject, data);

    try {
      let resp = await axios.post("login", formDataObject);
      localStorage.removeItem("preferred_locum_invitation_id");
      // resp.data.user.mobileNumber_verified = true;
      store.commit("SET_USER_DATA", resp.data.user);
      store.dispatch("AUTH_SUCCESS", resp.data.token);
    } catch (error) {
      errorHandler(error);
    }
  },

  async AUTH_LOGOUT(store) {
    try {
      window.localStorage.removeItem("one-signal-subscribed");
      window.localStorage.removeItem("emulate");
      store.commit("AUTH_LOGOUT");
    } catch (error) {
      store.commit("AUTH_LOGOUT");
      errorHandler(error);
    }
  },

  CLEAR_USER_DATA(store) {
    store.commit("CLEAR_USER_DATA");
  },

  AUTH_REMOVE_TOKEN(store) {
    store.commit("AUTH_LOGOUT");
  },

  SET_USER_DATA: ({ commit }, data) => {
    commit("SET_USER_DATA", data);
  },

  async UPDATE_USER_PHONE(store, data) {
    try {
      await axios.post("update-phone", data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async ADD_PREFERED_LOCUM(store, data) {
    try {
      await axios.post(
        store.getters.GET_USER_DATA.role + "/preferred-locums/invitation",
        data
      );
    } catch (error) {
      errorHandler(error);
    }
  },

  async ADD_GUEST_LOCUM(store, data) {
    try {
      await axios.post(
        store.getters.GET_USER_DATA.role + "/guest-locums/invitation",
        data
      );
    } catch (error) {
      errorHandler(error);
    }
  },

  async STORE_GUEST_LOCUM(store, data) {
    try {
      let resp = await axios.post(
        "/accept/guest-locum/" + data.invitationId,
        data.data
      );

      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPDATE_USER_EMAIL(store, data) {
    try {
      await axios.post("update-email", data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async VERIFY_USER_PHONE(store, data) {
    try {
      const resp = await axios.post("confirm-phone", data);
      // Call the 'fbq' function to track the CompleteRegistration event

      window.fbq("track", "CompleteRegistration");

      store.commit("SET_USER_DATA", {
        mobileNumber_verified: resp.data.status,
      });
    } catch (error) {
      errorHandler(error);
    }
  },

  async VERIFY_USER_EMAIL(store, data) {
    try {
      const resp = await axios.post("confirm-email", data);
      store.commit("SET_USER_DATA", {
        emailVerified: resp.data.status,
      });
    } catch (error) {
      errorHandler(error);
    }
  },

  async SET_CURRENT_USER_DATA(store, params) {
    try {
      const resp = await axios.get("me", {
        params: params,
      });

      store.commit("SET_USER_DATA", resp.data.user);
      store.getters.GET_USER_DATA;
    } catch (error) {
      errorHandler(error);
    }
  },

  async IDENTIFY_USER(store, data) {
    console.log("IDENTIFY CALLED", data);
    // const userId = store.getters.GET_USER_DATA.id;
    // Userpilot.identify(userId, data);
  },

  async SAVE_USER_DATA(store, data) {

    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/account-details",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_USER_PHARMACY_EXPERIENCE_DATA(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role +
        "/customfields/pharmacy_experience/save",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_USER_SOFTWARE_EXPERIENCE_DATA(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role +
        "/customfields/software_experience/save",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_USER_UNIVERSITY_DATA(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/customfields/universities/save",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async SAVE_USER_CERFICATIONS_DATA(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role +
        "/customfields/certificates/savewithfile",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_USER_EMAIL(store, data) {
    try {
      await axios.post("update-email", {
        email: data,
      });
      store.commit("SET_USER_DATA", {
        email: data,
      });
    } catch (error) {
      errorHandler(error);
    }
  },

  async SAVE_USER_PHONE(store, data) {
    try {
      await axios.post("update-phone", transformUserDataForRequest(data));
      store.commit("SET_USER_DATA", data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async DELETE_USER(store) {
    try {
      await axios.post("test/delete-user");
      store.commit("AUTH_LOGOUT");
    } catch (error) {
      errorHandler(error);
    }
  },

  async ACTIVATE_USER() {
    try {
      await axios.post("test/activate-user-account");
    } catch (error) {
      errorHandler(error);
    }
  },

  SET_USER_ROLE: ({ commit }, data) => {
    commit("SET_USER_ROLE", data);
  },
  SET_USER_PLATFORM_ROLE: ({ commit }, data) => {
    commit("SET_USER_PLATFORM_ROLE", data);
  },
  SET_USER_WORK_TYPE: ({ commit }, data) => {
    commit("SET_USER_WORK_TYPE", data);
  },
  SET_USER_EMAIL: ({ commit }, data) => {
    commit("SET_USER_EMAIL", data);
  },
  SET_USER_PHONE: ({ commit }, data) => {
    commit("SET_USER_PHONE", data);
  },

  async GET_USER_SCHEDULE(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/schedule"
      );
      store.commit("SET_USER_DATA", {
        schedule: resp.data.data,
      });
      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_USER_ENVIRONMENT(store, data) {
    const userData = data || store.getters.GET_USER_DATA;
    try {
      let [scriptsResp, softwareResp] = await Promise.all([
        store.dispatch("GET_PHARMACY_SCRIPTS_COUNT"),
        store.dispatch("GET_PHARMACY_SOFTWARE"),
      ]);

      let data = {
        scripts: userData.environment.scriptsPerDay
          ? scriptsResp.filter(
            (x) => x.id == userData.environment.scriptsPerDay
          )[0].name
          : null,
        average_scripts_saturday_id: userData.averageScriptsSaturdayId
          ? scriptsResp.filter(
            (x) => x.id == userData.averageScriptsSaturdayId
          )[0].name
          : null,
        average_scripts_sunday_id: userData.averageScriptsSundayId
          ? scriptsResp.filter(
            (x) => x.id == userData.averageScriptsSundayId
          )[0].name
          : null,
        number_of_patients: userData.numberOfPatients
          ? userData.numberOfPatients
          : null,
        software: userData.environment.software
          ? softwareResp.filter((x) => x.id == userData.environment.software)[0]
            .name
          : null,
        services: userData.environment.services
          ? userData.environment.services
          : null,
        additionalName1: userData.additionalName1
          ? userData.additionalName1
          : null,
        additionalName2: userData.additionalName2
          ? userData.additionalName2
          : null,
        additionalPhone1: userData.additionalPhone1
          ? userData.additionalPhone1
          : null,
        additionalPhone2: userData.additionalPhone2
          ? userData.additionalPhone2
          : null,
      };

      if (data.software?.toLowerCase() === "other") {
        data.softwareOther = userData.settings?.softwareOther;
      }

      store.commit("SET_USER_ENVIRONMENT_VALUE", data);
      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async GET_ENVIRONMENT_SETTING(store) {
    try {
      let [scriptsResp, softwareResp] = await Promise.all([
        store.dispatch("GET_PHARMACY_SCRIPTS_COUNT"),
        store.dispatch("GET_PHARMACY_SOFTWARE"),
      ]);

      let data = {
        scripts: scriptsResp ? scriptsResp : null,
        software: softwareResp ? softwareResp : null,
      };
      store.commit("SET_ENVIRONMENT_SETTING_VALUE", data);
      return data;
    } catch (error) {
      console.log(error);
    }
  },

  async GET_USER_GALLERY(store) {
    try {
      let url = "/gallery";
      let resp = await axios.get(store.getters.GET_USER_DATA.role + url);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPLOAD_USER_GALLERY_FILE(store, data) {
    try {
      let url = "/gallery/upload";
      let resp = await axios.post(store.getters.GET_USER_DATA.role + url, data);
      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async DELETE_USER_GALLERY_FILE(store, id) {
    try {
      let url = "/gallery/file/" + id;
      await axios.delete(store.getters.GET_USER_DATA.role + url);
    } catch (error) {
      errorHandler(error);
    }
  },

  async DELETE_JOB_SEEKER_FILE(store, id) {
    try {
      let url = "/gallery/file/" + id;
      await axios.delete(store.getters.GET_USER_DATA.role + url);
    } catch (error) {
      errorHandler(error);
    }
  },
  async DELETE_USER_COVID_CERT(store, file) {
    try {
      let url = "/files/" + file.id + "/covid-cert";
      await axios.delete(store.getters.GET_USER_DATA.role + url);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_ENVIRONMENT(store) {
    try {
      await Promise.all([
        store.dispatch("GET_PHARMACY_SERVICES"),
        store.dispatch("GET_PHARMACY_SCRIPTS_COUNT"),
        store.dispatch("GET_PHARMACY_SOFTWARE"),
      ]);
    } catch (error) {
      console.log(error);
    }
  },

  async PASSWORD_RESET(store) {
    console.log("reset email is", store.getters.GET_USER_DATA.email);
    try {
      const resp = await axios.put("reset-password", {
        email: store.getters.GET_USER_DATA.email,
      });
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async PASSWORD_CHANGE(store, data) {
    try {
      const resp = await axios.put("change-password", data);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async PASSWORD_NEW(store, data) {
    try {
      const resp = await axios.put("set-new-password", data);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_PHARMACY_SERVICES(store) {
    try {
      const resp = await axios.get("list/pharmacy-services");
      store.commit("SET_PHARMACY_SERVICES", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PHARMACY_SOFTWARE(store) {
    try {
      const resp = await axios.get("list/pharmacy-software");
      store.commit("SET_PHARMACY_SOFTWARE", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PHARMACY_SCRIPTS_COUNT(store) {
    try {
      const resp = await axios.get("list/pharmacy-scripts-count");
      store.commit("SET_PHARMACY_SCRIPTS_COUNT", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_STATES(store) {
    try {
      const resp = await axios.get("states");
      // Handle both resp.data and resp.data.data formats
      const statesData = resp.data?.data || resp.data || [];
      store.commit("SET_STATES", statesData);
      return statesData;
    } catch (error) {
      console.error("Error fetching states:", error);
      errorHandler(error);
      return [];
    }
  },
  async CREATE_JOB(store, payload) {
    try {
      await axios.post(store.getters.GET_USER_DATA.role + "/jobs", payload);
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPDATE_JOB(store, data) {
    try {
      await axios.put(
        store.getters.GET_USER_DATA.role + "/jobs/" + data.jobId,
        data.params
      );
    } catch (error) {
      errorHandler(error);
    }
  },

  async ADD_JOB(store) {
    try {
      const getRange = () => {
        let range = [];
        const shedule = store.state.pages.job.create.schedule;

        for (const date in shedule) {
          if (!isEmpty(store.state.pages.job.create.schedule[date])) {
            let scheduleDay = {
              date: moment(
                store.state.pages.job.create.schedule[date].date,
                "DD/MM/YYYY"
              ).format("YYYY-MM-DD"),

              start_time: moment(
                store.state.pages.job.create.schedule[date].timeStart,
                moment.ISO_8601
              ).format("HH:mm"),
              end_time: moment(
                store.state.pages.job.create.schedule[date].timeEnd,
                moment.ISO_8601
              ).format("HH:mm"),
            };
            range.push(scheduleDay);
          }
        }
        return range;
      };
      console.log("JOB OBJ?:", store.state.pages.job);
      let schedule = getRange();
      let platform_role_id = store.state.pages.job.create.platform_role_id;
      let covid_cert_required =
        store.state.pages.job.create.covid_cert_required;

      let req = {
        schedule: schedule,
        is_block_shift: store.state.pages.job.create.isBlockShift,
        min_rate: store.state.pages.job.create.minRate,
        max_rate: store.state.pages.job.create.maxRate,
        platform_role_id: platform_role_id,
        covid_cert_required: covid_cert_required,
        weekend_min_rate: store.state.pages.job.create.weekendMinRate,
        weekend_max_rate: store.state.pages.job.create.weekendMaxRate,
        languages: store.state.pages.job.create.languages,
        paying_for_travel: store.state.pages.job.create.paying_for_travel,
        enable_travel_allowance_for_first_and_last_day: store.state.pages.job.create.enable_travel_allowance_for_first_and_last_day,
        pay_for_flights: store.state.pages.job.create.pay_for_flights,
        pay_for_accommodation:
          store.state.pages.job.create.pay_for_accommodation,
        max_travel_compensation: store.state.pages.job.create.max_travel_amount,
        solo: store.state.pages.job.create.solo,
        open_up: store.state.pages.job.create.open_up,
        close: store.state.pages.job.create.close,
        admin_aids: store.state.pages.job.create.admin_aids,
        home_med_review: store.state.pages.job.create.home_med_review,
        num_of_tech: store.state.pages.job.create.num_of_tech,
        notes: store.state.pages.job.create.notes,
        parking: store.state.pages.job.create.parking,
        visibility_status: store.state.pages.job.create.visibility_status,
        more_option_internal_pools:
          store.state.pages.job.create.more_option_internal_pools,
        more_option_prefered_locum:
          store.state.pages.job.create.more_option_prefered_locum,
        more_option_open_marketplace:
          store.state.pages.job.create.more_option_open_marketplace,
        more_option_agency: store.state.pages.job.create.more_option_agency,
        job_lock_hour: store.state.pages.job.create.job_lock_hour,
        saturday_min_rate: store.state.pages.job.create.saturdayMinRate,
        saturday_max_rate: store.state.pages.job.create.saturdayMaxRate,
        sunday_min_rate: store.state.pages.job.create.sundayMinRate,
        sunday_max_rate: store.state.pages.job.create.sundayMaxRate,
        shift_application_type:
          store.state.pages.job.create.shift_application_type,
        application_radius:
          store.state.pages.job.create.application_radius === -1
            ? null
            : store.state.pages.job.create.application_radius,
      };
      console.log("State jobs", store.state.pages.job.create, req);

      await axios.post(store.getters.GET_USER_DATA.role + "/jobs", req);
    } catch (error) {
      errorHandler(error);
    }
  },

  async ADD_GUEST_SHIFT(store) {
    try {
      const getRange = () => {
        let range = [];
        const shedule = store.state.pages.guestShift.create.schedule;

        for (const date in shedule) {
          if (!isEmpty(store.state.pages.guestShift.create.schedule[date])) {
            let scheduleDay = {
              date: moment(
                store.state.pages.guestShift.create.schedule[date].date,
                "DD/MM/YYYY"
              ).format("YYYY-MM-DD"),

              start_time: moment(
                store.state.pages.guestShift.create.schedule[date].timeStart,
                moment.ISO_8601
              ).format("HH:mm"),
              end_time: moment(
                store.state.pages.guestShift.create.schedule[date].timeEnd,
                moment.ISO_8601
              ).format("HH:mm"),
            };
            range.push(scheduleDay);
          }
        }
        return range;
      };
      console.log("JOB OBJ?:", store.state.pages.guestShift);
      let schedule = getRange();

      let req = {
        schedule: schedule,
        pay_rate: store.state.pages.guestShift.create.payRate,
        shift_note: store.state.pages.guestShift.create.shiftNotes,
        first_name: store.state.pages.guestShift.create.firstName,
        last_name: store.state.pages.guestShift.create.lastName,
        email: store.state.pages.guestShift.create.email,
        mobile_number: store.state.pages.guestShift.create.mobileNumber,
        additional_term_condition:
          store.state.pages.guestShift.create.additionalTermCondition,
        request_aphra_insurance:
          store.state.pages.guestShift.create.requestAphraIns,
      };
      console.log("reguest of guest shift is", req);
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/add/guest-shift",
        req
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPLOAD_CONTRACT_SHIFT(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/add/guest-shift/contract",
        transformUserDataForRequest(data)
      );
      console.log("contract uploded", resp);
      store.commit("SET_USER_DATA", resp.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async GUEST_SHIFT_ACCEPT(store, data) {
    try {
      let guestShiftUrl = "/guest/accept/guest-shift";
      let resp = await axios.post(guestShiftUrl, data);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GUEST_SHIFT_REJECT(store, data) {
    try {
      let guestShiftUrl = "/guest/reject/guest-shift";
      let resp = await axios.post(guestShiftUrl, data);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_JOB_LIST_RECOMMENDED(store, params) {
    let jobsUrl = "/jobs/recommended";
    try {
      const fullUrl = store.getters.GET_USER_DATA.role + jobsUrl;
      console.log("GET_JOB_LIST_RECOMMENDED: Calling API with URL:", fullUrl);
      console.log("GET_JOB_LIST_RECOMMENDED: Params:", params);

      const resp = await axios.get(fullUrl, {
        params: params,
      });

      console.log("GET_JOB_LIST_RECOMMENDED: Response received");

      if (!resp || !resp.data || !resp.data.data) {
        throw new Error("Invalid API response structure");
      }

      resp.data.data.forEach((element) => {
        transformJobData(element);
      });

      console.log("GET_JOB_LIST_RECOMMENDED: Returning data");
      return resp.data;
    } catch (error) {
      console.error("GET_JOB_LIST_RECOMMENDED: Error occurred:", error);
      errorHandler(error);
      // Re-throw error so Promise.race can catch it
      throw error;
    }
  },

  async GET_JOB_LIST_OTHER(store, params) {
    let jobsUrl = "/jobs/other";
    try {
      const resp = await axios.get(store.getters.GET_USER_DATA.role + jobsUrl, {
        params: params,
      });
      resp.data.data.forEach((element) => {
        transformJobData(element);
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_JOB_INFO(store, data) {
    try {
      let jobUrl = "/jobs/" + data.jobId;
      let resp = await axios.get(store.getters.GET_USER_DATA.role + jobUrl, {
        params: data.params,
      });

      resp.data.data = transformJobData(resp.data.data);

      if (resp.data.data.shifts) {
        resp.data.data.shifts.forEach((element) => {
          transformShiftData(element, store);
        });
      }

      // Optimize the data before storing
      const optimizedData = getEssentialJobData(resp.data.data);
      store.commit("setJobDetails", optimizedData);

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_GUEST_SHIFT_INFO(store, data) {
    try {
      let guestShiftUrl = "/guest/guest-shift/" + data.jobId;
      let resp = await axios.get(guestShiftUrl);
      console.log("data aiyo hai guest shift ko", resp);
      store.commit("setGuestShiftPublic", resp.data);
      // resp.data.data = transformJobData(resp.data.data);
      // if (resp.data.data.shifts) {
      //   resp.data.data.shifts.forEach((element) => {
      //     transformShiftData(element, store);
      //   });
      // }

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_PREVIEW_GUEST_SHIFT_INFO(store, data) {
    try {
      let guestShiftUrl = "/guest/guest-shift/preview/" + data.jobId;
      let resp = await axios.get(guestShiftUrl);
      console.log("data aiyo hai guest shift ko", resp);
      store.commit("setGuestShiftPublic", resp.data);
      // resp.data.data = transformJobData(resp.data.data);
      // if (resp.data.data.shifts) {
      //   resp.data.data.shifts.forEach((element) => {
      //     transformShiftData(element, store);
      //   });
      // }

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_GUEST_SHIFT_DETAILS_FOR_PHARMACY(store, data) {
    try {
      let guestShiftUrl = "/guest/guest-shift/phamracy/details/" + data.shiftId;
      let resp = await axios.get(guestShiftUrl);
      console.log("data aiyo hai guest shift ko", resp);
      store.commit("setGuestShiftPublic", resp.data);
      // resp.data.data = transformJobData(resp.data.data);
      // if (resp.data.data.shifts) {
      //   resp.data.data.shifts.forEach((element) => {
      //     transformShiftData(element, store);
      //   });
      // }
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_INFO_DETAILS(store, data) {
    try {
      console.log("job actions");
      let jobUrl = "/jobs-detail/" + data.jobId;
      let resp = await axios.get(store.getters.GET_USER_DATA.role + jobUrl, {
        params: data.params,
      });
      console.log("🚀 ~ GET_JOB_INFO_DETAILS ~ resp:", resp)
      resp.data.data = transformJobData(resp.data.data);
      if (resp.data.data.shifts) {
        resp.data.data.shifts.forEach((element) => {
          transformShiftData(element, store);
        });
      }

      return resp.data;
    } catch (error) {
      errorHandler(error);
      throw error;
    }
  },
  async GET_JOB_URGENT_INFO(store, data) {
    try {
      let jobUrl = "/jobs-urgent/" + data.jobId;
      let resp = await axios.get(store.getters.GET_USER_DATA.role + jobUrl, {
        params: data.params,
      });
      resp.data.data = transformJobData(resp.data.data);
      if (resp.data.data.shifts) {
        resp.data.data.shifts.forEach((element) => {
          transformShiftData(element, store);
        });
      }

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_JOB_SHIFTS_LIST(store, data) {
    try {
      let jobUrl = "/jobs/" + data.jobId + "/shifts";
      const resp = await axios.get(store.getters.GET_USER_DATA.role + jobUrl, {
        params: data.params,
      });
      // Transform paginated pharmacy shift-details payloads
      if (resp.data?.data && Array.isArray(resp.data.data)) {
        resp.data.data.forEach((element) => {
          transformShiftData(element, store);
        });
      }
      return resp.data;
    } catch (error) {
      errorHandler(error);
      throw error;
    }
  },

  async SAVE_JOB_SHIFTS_LIST(store, data) {
    try {
      let jobUrl = "/shifts/assign";
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + jobUrl,
        data
      );
      store.commit("clearJobCreatePageData");
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async APPLY_JOB_SHIFTS_LIST(store, data) {
    try {
      let jobUrl = `/apply-for-shift/${data.job_id}`;
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + jobUrl,
        data
      );
      store.commit("clearJobCreatePageData");
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async ACKNOWLEDGE_ONBOARDING_DOCUMENT(store, data) {
    try {
      let url = data?.invitation_id
        ? "/onboarding-document/acknowledge"
        : "/locum/onboarding-document/acknowledge";
      const resp = await axios.post(
        url,
        data
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async LOCUM_ACKNOWLEDGE_ONBOARDING_DOCUMENT(store, data) {
    try {
      let url = "/locum/onboarding-document/acknowledge";
      const resp = await axios.post(
        url,
        data
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async LOCUM_REJECT_GROUP_ONBOARDING_DOCUMENT(store, data) {
    try {
      let url = "/locum/onboarding-document/reject-group";
      const resp = await axios.post(
        url,
        data
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_GROUP_MANAGER_DOCUMENTS(store, params) {
    try {
      let url = "/group-manager-documents";
      const resp = await axios.get(url, { params });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_ACKNOWLEDGED_DOCUMENTS(store, params) {
    try {
      let url = "/locum/acknowledged-documents";
      const resp = await axios.get(url, { params });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_PENDING_GROUP_MANAGER_DOCUMENTS(store, params) {
    try {
      let url = "/locum/pending-group-manager-documents";
      const resp = await axios.get(url, { params });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async FULFILLED_JOB_SHIFTS(store, data) {
    try {
      let jobUrl = "/shifts/fullfilled";
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + jobUrl,
        data
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_SHIFT_LIST(store, params) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/shifts",
        {
          params: params,
        }
      );
      resp.data.data.forEach((element) => {
        transformShiftData(element, store);
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_SHIFT_INFO(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId;
      let resp = await axios.get(store.getters.GET_USER_DATA.role + shiftUrl, {
        params: data.params,
      });
      resp.data.data = transformShiftData(resp.data.data, store);
      console.log("yoooooooo");
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async EDIT_SHIFT(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId;
      let resp = await axios.put(
        store.getters.GET_USER_DATA.role + shiftUrl,
        data.params
      );
      console.log(resp.data.data.job);
      store.commit("setCurrentJobNewData", resp.data.data.job);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async CONFIRM_SHIFT(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId + "/complete";
      let resp = await axios.put(
        store.getters.GET_USER_DATA.role + shiftUrl,
        data.params
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async CONFIRM_SHIFT_FORCE(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId + "/mark-as-completed";
      let resp = await axios.put(store.getters.GET_USER_DATA.role + shiftUrl);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async VIRIFY_SHIFT(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId + "/verify";
      let resp = await axios.put(store.getters.GET_USER_DATA.role + shiftUrl);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async EXIT_SHIFT(store, data) {
    try {
      // /${data.reason}
      let shiftUrl = `/shifts/${data.shiftId}/exit`;
      await axios.put(store.getters.GET_USER_DATA.role + shiftUrl, {
        reason: data.reason,
      });
    } catch (error) {
      errorHandler(error);
    }
  },

  async DELETE_SHIFT(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId;
      await axios.delete(store.getters.GET_USER_DATA.role + shiftUrl, {
        data: {
          reason: data.reason,
        },
      });
    } catch (error) {
      errorHandler(error);
    }
  },

  async WITHDRAW_APPLICANT_BY_PHARMACY(store, data) {
    console.log(
      "🚀 ~ file: actions.js:1038 ~ WITHDRAW_APPLICANT_BY_PHARMACY ~ data:",
      data
    );
    try {
      let Url =
        store.getters.GET_USER_DATA.role + "/shift-application-withdraw";
      await axios.post(Url, data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async REJECT_APPLICANT_BY_PHARMACY(store, data) {
    console.log(
      "🚀 ~ file: actions.js:1038 ~ WITHDRAW_APPLICANT_BY_PHARMACY ~ data:",
      data
    );
    try {
      let Url = store.getters.GET_USER_DATA.role + "/shift-application-delete";
      await axios.post(Url, data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async DISPUTE_SHIFT(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId + "/dispute";
      await axios.put(store.getters.GET_USER_DATA.role + shiftUrl, data.params);
    } catch (error) {
      errorHandler(error);
    }
  },

  async SHIFT_RATING(store, data) {
    try {
      let shiftUrl = "/shifts/" + data.shiftId + "/rating";
      let resp = await axios.put(
        store.getters.GET_USER_DATA.role + shiftUrl,
        data.params
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_JOB_SHIFTS_SCHEDULE(store, data) {
    try {
      await axios.get(store.getters.GET_USER_DATA.role + "/jobs/schedule", {
        params: data,
      });
    } catch (error) {
      errorHandler(error);
    }
  },

  async SEND_FEEDBACK(store, data) {
    try {
      await axios.post("/feedback", data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async SEND_REPORT(store, data) {
    try {
      await axios.post("/report", data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async SEND_SUPPORT(store, data) {
    try {
      await axios.post("/feedback", data);
      // store.commit('SET_USER_DATA', resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_LANGUAGES_LIST(store) {
    try {
      const resp = await axios.get("/list/languages");
      store.commit("setLanguagesList", resp.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_GUEST_SHIFT_INITIAL(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/pharmacy-guest-shift/detail"
      );
      store.commit("SET_USER_DATA", resp.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_STRIPE_CONNECT(store) {
    try {
      const resp = await axios.post("/billing/account");
      store.commit("setStripeConnectLink", resp.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_STRIPE_STATUS(store, id) {
    try {
      const resp = await axios.post("/billing/check-account-status", id);
      store.commit("setStripeConnectStatus", resp.data.status);
    } catch (error) {
      store.commit("setStripeConnectStatus", null);
      errorHandler(error);
    }
  },
  async GET_STRIPE_REFRESH(store) {
    try {
      const resp = await axios.get("/billing/refresh");
      store.commit("setStripeRefreshLink", resp.data.link);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PAYMENT_INTENT(store) {
    try {
      const resp = await axios.get("billing/payment-intent");
      store.commit("setPaymentIntent", resp.data);
      store.commit("setPaymentIntentCheck", Boolean(resp.data.clientSecret));
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_STRIPE_ACCOUNT(store) {
    try {
      const resp = await axios.post("billing/login-link ");
      store.commit("setStripeLoginLink", resp.data.link);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_BILLING_SESSION(store, data) {
    try {
      const resp = await axios.get(`billing/session/${data}`);
      store.commit("setPaymentIntent", resp.data);
      store.commit("setPaymentIntentCheck", Boolean(resp.data.clientSecret));
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_PREVIEW_INFO(store, data) {
    try {
      const resp = await axios.get(`jobs/${data.jobId}`, {
        params: data.params,
      });
      store.commit("setJobPreviewDetails", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async VERIFY_MOBILE_BANK_ACCOUNT(store, data) {
    try {
      await axios.post("verify-mobile", transformUserDataForRequest(data));
      store.commit("SET_USER_DATA", data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async VERIFY_USER_MOBILE_FOR_BANK(store, data) {
    try {
      const resp = await axios.post("confirm-mobile-for-bank", data);
      store.commit("SET_USER_DATA", {
        mobileNumber_verified: resp.data.status,
      });
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_USER_BANK_INFORMATION(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/bank-account/edit",
        transformUserDataForRequest(data)
      );
      console.log("bank data", resp);
      store.commit("SET_USER_DATA", resp.data.data);
      store.getters.GET_USER_DATA;
    } catch (error) {
      errorHandler(error);
    }
  },
  async VERIFY_BENEFICIARY_PAYMENT(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/verify/beneficiary/payment",
        transformUserDataForRequest(data)
      );
      console.log("verify ko response", resp);
    } catch (error) {
      errorHandler(error);
    }
  },

  // async AIRWALLEX_CREATE_BENIFICARY(store, data) {
  //   try {
  //     await axios.post(
  //       store.getters.GET_USER_DATA.role + "/airwallex/beneficiary/create",transformUserDataForRequest(data)
  //       );
  //   //  store.commit("SET_USER_DATA", resp.data.data);
  //   } catch (error) {
  //     errorHandler(error);
  //   }
  // },
  // async AIRWALLEX_CREATE_PAYMENT(store, data) {
  //   try {
  //     await axios.post(
  //       store.getters.GET_USER_DATA.role + "/airwallex/payment/create",transformUserDataForRequest(data)
  //       );
  //   //  store.commit("SET_USER_DATA", resp.data.data);
  //   } catch (error) {
  //     errorHandler(error);
  //   }
  // },

  async GET_ALL_BANK() {
    try {
      const resp = await axios.get("banks");
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PREFERRED_LOCUM_INFO(store, data) {
    try {
      let preferredLocum = "/preferred-locum/info/" + data.invitationId;
      let resp = await axios.get(preferredLocum);
      // console.log("data aiyo hai preferredLocum ko",resp);
      // store.commit("setGuestShiftPublic", resp.data);
      // resp.data.data = transformJobData(resp.data.data);
      // if (resp.data.data.shifts) {
      //   resp.data.data.shifts.forEach((element) => {
      //     transformShiftData(element, store);
      //   });
      // }

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_GUEST_LOCUM_INFO(store, data) {
    try {
      let guestLocum = "/guest-locum/info/" + data.invitationId;
      let resp = await axios.get(guestLocum);
      // console.log("data aiyo hai guestLocum ko",resp);
      // store.commit("setGuestShiftPublic", resp.data);
      // resp.data.data = transformJobData(resp.data.data);
      // if (resp.data.data.shifts) {
      //   resp.data.data.shifts.forEach((element) => {
      //     transformShiftData(element, store);
      //   });
      // }

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_EARNING_DASHBOARD(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role +
        "/" +
        store.getters.GET_USER_DATA.id +
        "/dashboard"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async SAVE_USER_DOCUMENT(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/file/upload",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  // async PREFERRED_LOCUM_ACCEPT(store, data) {
  //   try {
  //     let preferredLocum = "/preferred-locum/info/" + data.invitationId;
  //     let resp = await axios.get(preferredLocum);
  //     return resp;
  //   } catch (error) {
  //     errorHandler(error);
  //   }
  // },

  async DELETE_USER_DOCUMENT(store, file) {
    try {
      let url = "/gallery/file/" + file.id;
      const resp = await axios.delete(store.getters.GET_USER_DATA.role + url);
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_USER_INSURSNCE_DOCUMENT(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/insurance/upload",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async PREFERRED_LOCUM_ACCEPT(store, data) {
    try {
      let preferredLocum = "/accept/preferred-locum/" + data.invitationId;
      let resp = await axios.get(preferredLocum);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async INTERNAL_POOL_ACCEPT(store, data) {
    try {
      let internalPool = "/accept/internal-pool/" + data.invitationId;
      let resp = await axios.get(internalPool, {
        params: {
          device_name: data.device_name || navigator.platform || "Win32",
          address: data.address,
        }
      });

      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async INTERNAL_POOL_REJECT(store, data) {
    try {
      let internalPool = "/reject/internal-pool/" + data.invitationId;
      let resp = await axios.get(internalPool);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_INTERNAL_POOL_INFO(store, data) {
    try {
      let internalPool = "/internal-pool/invitation/info/" + data.invitationId;
      let resp = await axios.get(internalPool);
      // console.log("data aiyo hai preferredLocum ko",resp);
      // store.commit("setGuestShiftPublic", resp.data);
      // resp.data.data = transformJobData(resp.data.data);
      // if (resp.data.data.shifts) {
      //   resp.data.data.shifts.forEach((element) => {
      //     transformShiftData(element, store);
      //   });
      // }

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async REQUEST_ACCOUNT_DELETION(store, data) {
    try {
      const resp = await axios.post("request-account-deletion", data);
      console.log("respo", resp);
    } catch (error) {
      errorHandler(error);
    }
  },
  async PREFERRED_LOCUM_REJECT(store, data) {
    try {
      let preferredLocum = "/reject/preferred-locum/" + data.invitationId;
      let resp = await axios.get(preferredLocum);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GUEST_LOCUM_REJECT(store, data) {
    try {
      let guestLocum = "/reject/guest-locum/" + data.invitationId;
      let resp = await axios.get(guestLocum);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_GUEST_LOCUMS_LIST(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/guest-locums"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_AGENCIES(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/agencies"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_INTERNAL_EMPLOYEE_GROUPS(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/available-tags"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PREFERED_LOCUMS_LIST(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/get-on-boarded-preferred-locum"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async saveCv(store, data) {
    try {
      const resp = await axios.post(
        `${store.getters.GET_USER_DATA.role}/file/upload`,
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async deleteCv(store, file) {
    try {
      const resp = await axios.delete(
        `${store.getters.GET_USER_DATA.role}/gallery/file/${file.id}`
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async ACCEPT_TERMS_CONDITIONS(store) {
    try {
      const resp = await axios.post(
        "accept/term-and-condition/" + store.getters.GET_USER_DATA.id
      );
      console.log("return terms response", resp);
      // store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async AWARD_SHIFT(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/shift-application-awarded",
        data
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_SHIFT_APPLICATION_DETAILS(store, data) {
    try {
      let shiftApplicationUrl = `${store.getters.GET_USER_DATA.role}/shift-application/${data.shiftApplicationId}`;
      let resp = await axios.get(shiftApplicationUrl);
      store.commit("setShiftApplictionDetails", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async ACCEPT_REJECT_SHIFT_APPLICATION(store, data) {
    try {
      let shiftApplicationUrl = `${store.getters.GET_USER_DATA.role}/shift-application/${data.shiftApplicationId}`;
      let resp = await axios.post(shiftApplicationUrl, data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_PROFILE_USER_INFO(store, data) {
    try {
      let profileUrl = "/profile/" + data.userId;
      let resp = await axios.get(store.getters.GET_USER_DATA.role + profileUrl);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_AWARD_SHIFT_DETAIL_INFO(store, data) {
    try {
      let shiftUrl =
        "/shift-application/" +
        data.shiftAppId +
        "/" +
        data.pharmacyId +
        "/" +
        data.locumId;
      let resp = await axios.get(store.getters.GET_USER_DATA.role + shiftUrl, {
        params: { hideLoading: true, with: "application_documents" },
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async WITHDRAW_SHIFT_APPLICATION(store, data) {
    try {
      let shiftApplicationUrl = `${store.getters.GET_USER_DATA.role}/shift-application/${data.shiftApplicationId}/withdraw`;
      let resp = await axios.post(shiftApplicationUrl, data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async BULK_OFFER(store, data) {
    try {
      let shiftApplicationUrl = `${store.getters.GET_USER_DATA.role}/shift-application/bulk-offer`;
      let resp = await axios.post(shiftApplicationUrl, data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async BULK_DECLINE(store, data) {
    try {
      let shiftApplicationUrl = `${store.getters.GET_USER_DATA.role}/shift-application/bulk-decline`;
      let resp = await axios.post(shiftApplicationUrl, data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async ADD_AGENCY_NOTES(store, data) {
    try {
      const resp = await axios.post("/agency/notes/", data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async SAVE_AGENCY_NOTES(store, data) {
    try {
      const resp = await axios.post("/agency/notes/" + data.id, data.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async SAVE_INTERNAL_POOL_USER_PERFERENCE(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role +
        "/internal-pool-user/update-preference",
        data
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_EMPLOYEE_LOCUM_INFO(store, data) {
    try {
      let internalLocum = "/internal-employee/info/" + data.invitationId;
      let resp = await axios.get(internalLocum);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async EMPLOYEE_LOCUM_REJECT(store, data) {
    try {
      let preferredLocum = "/reject/internal-employee/" + data.invitationId;
      let resp = await axios.get(preferredLocum);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async EMPLOYEE_LOCUM_ACCEPT(store, data) {
    try {
      let internalEmployee = "/accept/internal-employee/" + data.invitationId;
      let resp = await axios.post(
        internalEmployee,
        transformUserDataForRequest(data.data)
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PHARMACY_INVITATION_INFO(store, data) {
    try {
      let groupManagerPharmacy =
        "/group-manager-pharmacy-invitation/info/" + data.invitationId;
      let resp = await axios.get(groupManagerPharmacy);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async PHARMACY_INVITATION_REJECT(store, data) {
    try {
      let groupManagerPharmacy =
        "/reject/group-manager-pharmacy-invitation/" + data.invitationId;
      let resp = await axios.get(groupManagerPharmacy);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async PHARMACY_INVITATION_ACCEPT(store, data) {
    try {
      let groupManagerPharmacy =
        "/accept/group-manager-pharmacy-invitation/" + data.invitationId;
      let resp = await axios.post(groupManagerPharmacy);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async ADD_PREFERRED_LOCUM_FROM_PROFILE(store, data) {
    try {
      let apiUrl = `${store.getters.GET_USER_DATA.role}/add-remove-preferred-locum-from-profile`;
      let resp = await axios.post(apiUrl, data);
      store.commit("SET_USER_DATA", resp.data.user);
    } catch (error) {
      errorHandler(error);
    }
  },
  async ADD_LOCUM_TO_BLACKLIST_FROM_PROFILE(store, data) {
    try {
      let apiUrl = `${store.getters.GET_USER_DATA.role}/add-remove-locum-to-blacklist-from-profile`;
      let resp = await axios.post(apiUrl, data);
      store.commit("SET_USER_DATA", resp.data.user);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async BLOCK_PHARMACY(store, data) {
    try {
      let apiUrl = `${store.getters.GET_USER_DATA.role}/hide-unhide-pharmacy`;
      let resp = await axios.post(apiUrl, data);
      store.commit("setLocumBlockedPharmacies", resp.data.data);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_LOCUM_BLOCKED_PHARMACIES(store) {
    try {
      let apiUrl = `${store.getters.GET_USER_DATA.role}/blocked-pharmacies`;
      let resp = await axios.get(apiUrl);
      store.commit("setLocumBlockedPharmacies", resp.data.data);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async CHECK_MAINTENANCE_MODE() {
    const resp = await axios.get("/maintenance");
    return resp;
  },
  async CONTRACTOR_ONBOARDING_COMPLETE() {
    const resp = await axios.put("locum/complete-contractor-onboarding");
    return resp;
  },
  async ENABLE_MARKETPLACE_PROCESS_COMPLETE() {
    const resp = await axios.put("locum/enable-marketplace");
    return resp;
  },
  async SAVE_JOB_SEEKER_NAME(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/onboard/name",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_SEEKER_BROWSE_JOB_LIST(store, params) {
    try {
      let jobSeekerJobList = "job-seeker/job-post";
      let resp = await axios.get(jobSeekerJobList, {
        params: params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_SEEKER_APPLICANT_JOB_LIST(store, params) {
    try {
      let jobSeekerApplicationJobList = "job-seeker/job-post-applications";
      let resp = await axios.get(jobSeekerApplicationJobList, {
        params: params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_SEEKER_PREVIOUS_JOB_LIST(store, params) {
    try {
      let jobSeekerPreviousJobList =
        "/job-seeker/previous/job-post-applications";
      let resp = await axios.get(jobSeekerPreviousJobList, {
        params: params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_SEEKER_JOB_POST(store, data) {
    console.log("🚀 ~ JOB_SEEKER_JOB_POST ~ data:", data);
    try {
      let jobUrl = "job-seeker/job-post/" + data.jobId;
      let resp = await axios.get(jobUrl, {
        params: data.params,
      });
      return resp.data;
    } catch (error) {
      const isJobNotAvailable = error.response?.status === 410 || error.response?.data?.code === 410 || error.response?.data?.code === 'JOB_NOT_AVAILABLE';
      if (isJobNotAvailable) {
        throw error;
      }
      errorHandler(error);
    }
  },
  async JOB_SEEKER_APPLICATION_DETAILS_WITHDRAW(store, data) {
    console.log("🚀 ~ JOB_SEEKER_APPLICATION_POST ~ data:", data);
    try {
      let jobUrl = "job-seeker/job-post-application/" + data.jobId;
      let resp = await axios.get(jobUrl, {
        params: data.params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_JOB_SEEKER_ADDRESS(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/onboard/address",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_SEEKER_LEVEL(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/onboard/profile-type"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_JOB_SEEKER_SETTINGS(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/onboard/settings/store",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_JOB_SEEKER_EXPERIENCE(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/onboard/job-post-year-experiences"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_SEEKER_CATEGORY(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/onboard/job-post-categories"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_JOB_SEEKER_IMAGE(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/onboard/save/image",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_JOB_ENHANCE(store, data) {
    try {
      const config = {
        params: {
          hideLoading: true,
        },
      };
      const resp = await axios.post(
        "job-seeker/onboard/enhance-profile",
        transformUserDataForRequest(data),
        config
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_JOB_PREVIEW_PUBLISH(store, data) {
    try {
      const resp = await axios.post(
        "job-seeker/onboard/preview-publish",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_JOB_COMPLETE(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/onboard/survey-complete",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_POSTER_LISTINGS() {
    try {
      const resp = await axios.get("job-board/job-post-attributes", {
        params: {
          hideLoading: true,
        },
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_POSTER_SKILLS() {
    try {
      const resp = await axios.get("/job-board/popular-skills");
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_POSTER_DESC_AI(store, params) {
    try {
      let req = {
        min_rate: store.state.pages.jobListing.create.min_rate,
        max_rate: store.state.pages.jobListing.create.max_rate,
        job_type: store.state.pages.jobListing.create.job_type,
        job_title: store.state.pages.jobListing.create.job_title,
        job_location: store.state.pages.jobListing.create.job_location,
        job_category: store.state.pages.jobListing.create.job_category,
        job_skills: store.state.pages.jobListing.create.job_skills,
        rate_type: store.state.pages.jobListing.create.rate_type,
        bonus: store.state.pages.jobListing.create.bonus,
        platform_role_id: store.state.pages.jobListing.create.platform_role_id,
        hide_salary: store.state.pages.jobListing.create.hide_salary,
      };

      // Merge params and req objects
      const mergedParams = { ...req, ...params.params };

      const resp = await axios.get("job-board/expand-job-description", {
        params: mergedParams,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_JOB_POST(store, data) {
    try {
      let req = {
        min_rate: store.state.pages.jobListing.create.min_rate,
        max_rate: store.state.pages.jobListing.create.max_rate,
        job_type: store.state.pages.jobListing.create.job_type,
        job_title: store.state.pages.jobListing.create.job_title,
        job_location: JSON.stringify(
          store.state.pages.jobListing.create.job_location
        ),
        job_category: store.state.pages.jobListing.create.job_category,
        job_skills: store.state.pages.jobListing.create.job_skills,
        rate_type: store.state.pages.jobListing.create.rate_type,
        bonus: store.state.pages.jobListing.create.bonus,
        job_description: store.state.pages.jobListing.create.job_description,
        short_description:
          store.state.pages.jobListing.create.short_description,
        questionary: store.state.pages.jobListing.create.questionary,
        questions: store.state.pages.jobListing.create.questions,
        job_post_payment_id:
          store.state.pages.jobListing.create.job_post_payment_id,
        payment_intent_id:
          store.state.pages.jobListing.create.payment_intent_id,
        stripe_customer_id:
          store.state.pages.jobListing.create.stripe_customer_id,
        pharmacy_id: store.getters.GET_USER_DATA.id,
        save_as: data,
        coupon: store.state.appliedCoupon ? store.state.appliedCoupon.id : null,
        platform_role_id: store.state.pages.jobListing.create.platform_role_id,
        federal_pharmacist_support: store.state.pages.jobListing.create.federal_pharmacist_support,
        hide_salary: store.state.pages.jobListing.create.hide_salary,

      };

      const resp = await axios.post("job-board/job-post", req);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_POSTER_JOB_LIST(store, params) {
    try {
      let jobPosterJobList = "job-board/job-post";
      let resp = await axios.get(jobPosterJobList, {
        params: params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_POSTER_PREVIOUS_JOB_LIST(store, params) {
    try {
      let jobPosterPreviousJobList = "job-board/previous/job-post";
      let resp = await axios.get(jobPosterPreviousJobList, {
        params: params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_POSTER_APPLICANTS_LIST(store, params) {
    try {
      let jobPosterApplicantsJobList = "job-board/applicants";
      let resp = await axios.get(jobPosterApplicantsJobList, {
        params: params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_SEEKER_EXISTING_CV(store) {
    try {
      const resp = await axios.get(store.getters.GET_USER_DATA.role + "/cvs");
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_POST_PRICE_INFOS() {
    try {
      const resp = await axios.get("job-post-price-infos");
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_JOB_APPLICANT_STATUS_CATEGORIES() {
    try {
      const resp = await axios.get("job-board/applicant-status", {
        params: {
          hideLoading: true,
        },
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UPDATE_JOB_APPLICANT_STATUS_CATEGORY(store, data) {
    try {
      const resp = await axios.put(
        "job-board/update-applicant-status/" + data.applicationId,
        {
          status: data.payload.status,
        }
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UPDATE_BULK_JOB_APPLICANT_STATUS_CATEGORY(store, data) {
    try {
      const resp = await axios.put("job-board/categorize-applications/", {
        status: data.payload.status,
        applicationIds: data.payload.applicationIds,
      });
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async BULK_NOTIFY_SEEKER(store, data) {
    try {
      const resp = await axios.post("job-board/notify-applications", data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async APPLY_JOB_BY_JOBSEEKER(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/job-post-apply",
        data
      );

      return resp.data;
      // store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      const isJobNotAvailable = error.response?.status === 410 || error.response?.data?.code === 410 || error.response?.data?.code === 'JOB_NOT_AVAILABLE';
      if (isJobNotAvailable) {
        throw error;
      }
      errorHandler(error);
    }
  },

  async WITHDRAW_JOB_POST(store, data) {
    try {
      const resp = await axios.put(
        "job-board/withdraw-job-post/" + data.jobPostId,
        {
          withdrawn_reason: data.payload.reason,
        }
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async EXTERNALLY_FILLED_JOB_POST(store, data) {
    try {
      const resp = await axios.put(
        "job-board/mark-as-externally-filled/" + data.jobPostId
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async CLOSE_JOB_POST(store, data) {
    try {
      const resp = await axios.post(
        "job-board/close-job-post/" + data.jobPostId,
        {
          closed_reason: data.payload.reason,
        }
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async WITHDRAW_JOB_APPLICATION(store, data) {
    try {
      const resp = await axios.put(
        "job-seeker/withdraw-job-application/" + data.applicationId
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async SINGLE_NOTIFY_JOBSEEKER(store, data) {
    try {
      const resp = await axios.put(
        "job-board/award/" + data.jobId + "/" + data.applicationId
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async FETECH_JOB_DETAIL_ID(store, data) {
    console.log("🚀 ~ FETECH_JOB_DETAIL_ID ~ data:", data);
    try {
      const resp = await axios.get("job-board/job-post/" + data);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async FETECH_SEEKER_WISHLIST(store, data) {
    console.log("🚀 ~ FETECH_JOB_DETAIL_ID ~ data:", data);
    try {
      const resp = await axios.get("job-seeker/wishlists");
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async SAVE_SEEKER_WISHLIST_NAME(store, data) {
    try {
      const resp = await axios.post("job-seeker/wishlist", data);

      return resp.data;
      // store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async ADD_WISHLIST_FAV(store, data) {
    try {
      let addWishlist =
        "/job-seeker/add-to-wishlist/" + data.jobId + "/" + data.wishlistId;
      const config = {
        params: {
          hideLoading: true,
        },
      };

      let resp = await axios.post(addWishlist, {}, config);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UPDATE_JOB_POST(store, data) {
    console.log("🚀 ~ UPDATE_JOB_POST ~ data:", data.params);

    try {
      const resp = await axios.put(
        "job-board/job-post/" + data.jobId,
        data.params
      );
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPDATE_JOB_POST_WITH_PAYMENT(store, data) {
    console.log("🚀 ~ UPDATE_JOB_POST ~ data:", data.params);
    let req = {
      min_rate: store.state.pages.jobListing.create.min_rate,
      max_rate: store.state.pages.jobListing.create.max_rate,
      job_type: store.state.pages.jobListing.create.job_type,
      job_title: store.state.pages.jobListing.create.job_title,
      job_location: store.state.pages.jobListing.create.job_location,
      job_category: store.state.pages.jobListing.create.job_category,
      job_skills: store.state.pages.jobListing.create.job_skills,
      rate_type: store.state.pages.jobListing.create.rate_type,
      bonus: store.state.pages.jobListing.create.bonus,
      job_description: store.state.pages.jobListing.create.job_description,
      short_description: store.state.pages.jobListing.create.short_description,
      questionary: store.state.pages.jobListing.create.questionary,
      questions: store.state.pages.jobListing.create.questions,
      job_post_payment_id:
        store.state.pages.jobListing.create.job_post_payment_id,
      payment_intent_id: store.state.pages.jobListing.create.payment_intent_id,
      platform_role_id: store.state.pages.jobListing.create.platform_role_id,
      stripe_customer_id:
        store.state.pages.jobListing.create.stripe_customer_id,
      pharmacy_id: store.getters.GET_USER_DATA.id,
      hide_salary: store.state.pages.jobListing.create.hide_salary,
      save_as: "publish",
    };
    try {
      const resp = await axios.put("job-board/job-post/" + data.jobId, req);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPDATE_JOB_SEEKER_SETTING(store, data) {
    try {
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + "/update-setting",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async LOCUM_UPDATE_JOB_SEEKER_SETTING(store, data) {
    try {
      const resp = await axios.put(
        "job-seeker/update-setting",
        transformUserDataForRequest(data)
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },

  async GET_SKILLS(store, data) {
    try {
      const resp = await axios.get("job-board/skills", {
        params: {
          search: data?.search,
          id: data?.id,
        },
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_ALL_SKILLS(store, data) {
    try {
      const resp = await axios.get("job-seeker/get-all-skills", {
        params: {
          search: data?.search,
        },
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UPDATE_JOB_SEEKER_ABOUT(store, data) {
    try {
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + "/update-about-me",
        data.params
      );
      store.commit("SET_USER_DATA", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPDATE_JOB_SEEKER_EXPERIENCES(store, data) {
    try {
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + "/update-experiences",
        data
      );
      store.commit("SET_USER_DATA", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UPDATE_JOB_SEEKER_EDUCATIONS(store, data) {
    try {
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + "/update-educations",
        data
      );
      store.commit("SET_USER_DATA", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UPDATE_JOB_SEEKER_CERTIFICATES(store, data) {
    try {
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + "/update-certificates",
        data
      );
      store.commit("SET_USER_DATA", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },

  async UPDATE_JOB_SEEKER_SKILLS(store, data) {
    try {
      const resp = await axios.put(
        store.getters.GET_USER_DATA.role + "/update-skills",
        data.params
      );
      store.commit("SET_USER_DATA", resp.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async REMOVE_JOB_FROM_JOB_SEEKER_LIST(store, data) {
    try {
      let removeJobPostUrl = "/job-seeker/remove-jobs/" + data.jobId;
      let resp = await axios.post(removeJobPostUrl);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async TOGGLE_FAVORITE(store, data) {
    try {
      let toggleFavorite = "/job-seeker/toggle-favorite/" + data.jobId;
      let resp = await axios.post(toggleFavorite);
      return resp;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_BLOCK_SHIFT_SHIFTS(store, data) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/bulk-shifts/" + data.shiftId,
        {
          params: data.params,
        }
      );

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_APPLICANT_DETAIL(store, data) {
    try {
      let resp = await axios.get("/job-board/applicant/" + data.applicationId);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async CREATE_PAYMENT_INTENT(store, data) {
    try {
      const resp = await axios.post("job-board/create-payment-intent", data);
      const {
        clientSecret,
        jobPostPaymentId,
        paymentIntentId,
        stripeCustomerId,
        amountDue,
        amountPaid,
        amountRemaining,
        discountAmounts,
      } = resp.data;
      return {
        clientSecret,
        jobPostPaymentId,
        paymentIntentId,
        stripeCustomerId,
        amountDue,
        amountPaid,
        amountRemaining,
        discountAmounts,
      };
    } catch (error) {
      errorHandler(error);
    }
  },
  async GUEST_BROWSE_JOB_LIST(store, params) {
    try {
      let jobSeekerJobList = "guest/job-post";
      let resp = await axios.get(jobSeekerJobList, {
        params: params,
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_GUEST_JOB_LISTINGS() {
    try {
      const resp = await axios.get("guest/job-post-attributes", {
        params: {
          hideLoading: true,
        },
      });
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async JOB_LISTING_GUEST_JOB_DETAIL(store, data) {
    try {
      let jobUrl = "guest/job-post/" + data.jobId;
      let resp = await axios.get(jobUrl, {
        params: data.params,
      });
      return resp.data;
    } catch (error) {
      const isJobNotAvailable = error.response?.status === 410 || error.response?.data?.code === 410 || error.response?.data?.code === 'JOB_NOT_AVAILABLE';
      if (isJobNotAvailable) {
        throw error;
      }
      if (error.response?.status === 404) {
        router.push({ name: "NotFound" });
      } else {
        errorHandler(error);
      }
    }
  },
  async GET_CUSTOM_FIELDS(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/customfields"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PLATFORM_ROLE(store) {
    try {
      const resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/platform-roles"
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_SUBSCRIBE_JOBS_DATA(store, data) {
    try {
      let jobUrl = "job-board/subscribe-jobs";
      if (data.isGuest) {
        jobUrl = "job-board/guest/subscribe-jobs";
      }
      let resp = await axios.get(jobUrl);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UPDATE_SUBSCRIBE_JOBS_DATA(store, data) {
    try {
      let jobUrl = "job-board/subscribe-jobs";
      if (data.isGuest) {
        jobUrl = "job-board/guest/subscribe-jobs";
      }
      let resp = await axios.put(jobUrl, data.formData);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async CONFIRM_JOB_ALERT_SUBSCRIPTION_GUEST(store, data) {
    try {
      let jobUrl = "job-board/guest/subscribe-jobs/confirm";
      let resp = await axios.put(jobUrl, data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UNSUBSCRIBE_JOB_ALERT() {
    try {
      let jobUrl = "job-board/unsubscribe";
      let resp = await axios.put(jobUrl);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async UNSUBSCRIBE_JOB_ALERT_GUEST(store, data) {
    try {
      let jobUrl = "job-board/guest/unsubscribe";
      let resp = await axios.put(jobUrl, data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_JOB_NOTIFY_TEMPLATES() {
    try {
      const resp = await axios.get(
        "job-board/category-update-email-templates",
        {
          params: {
            hideLoading: true,
          },
        }
      );
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async RENAME_CV(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/user-file/rename",
        data
      );
      store.commit("SET_USER_DATA", resp.data.data);
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PHARMACY_TYPES(store) {
    try {
      const resp = await axios.get("pharmacy/pharmacy-types");
      store.commit("setPharmacyTypes", resp.data.data);
      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async APPLY_COUPON_CODE(store, data) {
    try {
      const resp = await axios.post("/job-board/check-coupon", data);
      store.commit("setAppliedCoupon", resp.data.data);
      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async CLEAR_APPLIED_COUPON(store) {
    try {
      store.commit("setAppliedCoupon", {});
    } catch (error) {
      errorHandler(error);
    }
  },
  async REMOVE_SELECTED_SHIFT_FROM_BULK_SHIFT(store, data) {
    try {

      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/delete-bulk-shifts/",
        data
      );

      return resp.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PHARMACY_SUB_TYPES(store, data) {
    try {
      const resp = await axios.get(store.getters.GET_USER_DATA.role + "/pharmacy-sub-types/" + data.siteId);
      // store.commit("setPharmacyTypes", resp.data.data);
      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_PHARMACY_ADDITIONAL_INFO_FIELDS(store) {
    if (store.getters.GET_USER_DATA.role === "locum" || store.getters.GET_USER_DATA.role === "pharmacy") {
      try {
        const resp = await axios.get(store.getters.GET_USER_DATA.role + "/customfields");
        store.commit("setPharmacyAdditionalInfo", resp.data.data);
        return resp.data.data;
      } catch (error) {
        errorHandler(error);
      }
    }
  },
  async SAVE_ADDITIONAL_PHARMACY_INFO(store, data) {
    try {

      const resp = await axios.post(
        // customfields/{category}/save
        "pharmacy/customfields/" + data[0].key + "/save",
        data
      )
      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async INVITE_INTERNAL_POOL(store, data) {
    try {
      const resp = await axios.post(
        store.getters.GET_USER_DATA.role + "/invite/internal-pool", data
      );
      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },
  async GET_INTERNAL_POOL_LISTS(store) {
    try {
      let resp = await axios.get(
        store.getters.GET_USER_DATA.role + "/internal-pool-lists"
      );

      return resp.data.data;
    } catch (error) {
      errorHandler(error);
    }
  },
};
